export default Object.freeze([
  '2D Animation',
  '3D Animation',
  'Action',
  'Animation',
  'Claymation',
  'Comedy',
  'Dark Comedy',
  'Documentary',
  'Drama',
  'Experimental',
  'Family Drama',
  'Fantasy',
  'Horror',
  'Mockumentary',
  'Noir',
  'Psychological Thriller',
  'Romance',
  'Sci-Fi',
  'Slasher',
  'Thriller',
]);



// WEBPACK FOOTER //
// ./src/assets/data/viddsee/genres.js